function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11 21c5.523 0 10-4.477 10-10S16.523 1 11 1 1 5.477 1 11s4.477 10 10 10zM6.967 8.366h8.057",
  stroke: "#1D1D1B",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.265 6.68l1.759 1.677-1.759 1.767M15.024 13.633H6.967M8.735 15.328l-1.768-1.676 1.768-1.768",
  stroke: "#1D1D1B",
  strokeWidth: 1.2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgExchange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "33764a555fdfce0033498b716972009d.svg";
export { SvgExchange as ReactComponent };